import React from 'react';
import '../styles/ZwykFeatures.css';
import PhoneImage from '../assets/phone-on-tree.avif';
import ZwykList from './ZwykList';

const Container: React.FC = () => {
  return (
    <div className="features-container">
      <div className="image-container">
        <img src={PhoneImage} alt="Zwyk" />
      </div>
      <div className="text-container">
        <ZwykList items={
            [
                {
                    header: 'Twórz wycieczki',
                    description: 'Planuj własne wyprawy i zapraszaj innych użytkowników do wspólnej przygody. Ustal trasę, termin i poziom trudności.'
                },
                {
                    header: 'Przeglądaj trasy użytkowników',
                    description: 'Odkrywaj ciekawe szlaki dodane przez społeczność. Znajdź inspirację na kolejne wyprawy i zobacz opinie innych podróżników.'
                },
                {
                    header: 'Zapisuj się do lokalnych inicjatyw',
                    description: 'Dołącz do grup pasjonatów górskich i turystycznych w swojej okolicy. Bierz udział w zorganizowanych wydarzeniach i poznawaj nowych ludzi.'
                },
                {
                    header: 'Znajdź przewodnika lub kompana',
                    description: 'Nie chcesz wędrować sam? Skorzystaj z aplikacji, aby znaleźć doświadczonego przewodnika lub towarzysza na wspólne wyprawy.'
                },
                {
                    header: 'Zdobywaj odznaki za aktywność',
                    description: 'Zbieraj osiągnięcia za pokonane szlaki i pomoc innym. Odblokowuj unikalne odznaki i dziel się swoimi sukcesami w społeczności.'
                },
            ]
        } />
      </div>
    </div>
  );
};

export default Container; 